var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { StreamIDUtils, StreamPartIDUtils, toEthereumAddress, toStreamID, toStreamPartID } from '@streamr/utils';
import { Lifecycle, inject, scoped } from 'tsyringe';
import { Identity, IdentityInjectionToken } from './identity/Identity';
export const DEFAULT_PARTITION = 0;
function pickStreamId(definition) {
    const obj = definition;
    if (obj.id !== undefined) {
        return obj.id;
    }
    else if (obj.stream !== undefined) {
        return obj.stream;
    }
    else if (obj.streamId !== undefined) {
        return obj.streamId;
    }
    else {
        throw new Error('streamDefinition: object must have property: "id", "stream", or "streamId"');
    }
}
function parseRawDefinition(definition) {
    if (typeof definition === 'string') {
        return StreamPartIDUtils.parseRawElements(definition);
    }
    else if (typeof definition === 'object') {
        return [pickStreamId(definition), definition.partition];
    }
    else {
        throw new Error('streamDefinition: must be of type string or object');
    }
}
let StreamIDBuilder = class StreamIDBuilder {
    identity;
    constructor(identity) {
        this.identity = identity;
    }
    async toStreamID(streamIdOrPath) {
        let address;
        if (StreamIDUtils.isPathOnlyFormat(streamIdOrPath)) {
            address = toEthereumAddress(await this.identity.getUserId());
        }
        return toStreamID(streamIdOrPath, address);
    }
    async toStreamPartID(definition) {
        const [streamId, streamPartition] = await this.toStreamPartElements(definition);
        return toStreamPartID(streamId, streamPartition ?? DEFAULT_PARTITION);
    }
    async toStreamPartElements(definition) {
        const [streamId, streamPartition] = parseRawDefinition(definition);
        return [await this.toStreamID(streamId), streamPartition];
    }
    async getMatcher(definition) {
        const [targetStreamId, targetPartition] = await this.toStreamPartElements(definition);
        return ((streamPartId) => {
            return targetStreamId === StreamPartIDUtils.getStreamID(streamPartId)
                && (targetPartition === undefined || targetPartition === StreamPartIDUtils.getStreamPartition(streamPartId));
        });
    }
};
StreamIDBuilder = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __param(0, inject(IdentityInjectionToken)),
    __metadata("design:paramtypes", [Identity])
], StreamIDBuilder);
export { StreamIDBuilder };
